import _ from "lodash";
/**--external-- */
import React from "react";
import classNames from "classnames";
import { SideNavigation } from "@toddle-edu/ds-web";

/**--relative-- */
import classes from "./Sidebar.scss";

const ROOT_TIER = 2;
const CHILD_TIER = 1;

const _getSidebarOptions = ({
  suggestedEvidenceOptions = [],
  options,
  t,
  selectedEvidences,
}) => {
  const allOptions = [
    ...suggestedEvidenceOptions,
    ...(_.size(suggestedEvidenceOptions) > 0
      ? [{ key: "divider", label: "Divider" }]
      : []),
    { key: "optionsNode" },
  ];

  const rootNode = {
    key: "root",
    tier: ROOT_TIER,
    children: _.map(allOptions, ({ key }) => key),
  };

  const itemCountClasses = classNames("text-label-s", classes.itemCount);

  const childNodesForSuggestedEvidenceOptions = [
    ..._.map(suggestedEvidenceOptions, ({ key, config }) => {
      const selectedEvidencesCount = _.size(_.get(selectedEvidences, key, []));
      const showNotificationDot = config?.showNotificationDot;

      return {
        key,
        tier: CHILD_TIER,
        parent: "root",
        title: _.capitalize(t(config.label)),
        suffix: (
          <React.Fragment>
            {selectedEvidencesCount > 0 ? (
              <span className={itemCountClasses}>{selectedEvidencesCount}</span>
            ) : null}
            {showNotificationDot ? <span className={classes.dot} /> : null}
          </React.Fragment>
        ),
      };
    }),
    {
      key: "divider",
      tier: CHILD_TIER,
      parent: "root",
      title: "Divider",
      isDivider: true,
    },
  ];

  const optionsNode = {
    parent: "root",
    key: "optionsNode",
    children: _.map(options, "key"),
    title: t("common:name_from_toddle", {
      name: t("common:evidence"),
    }),
    tier: ROOT_TIER,
  };

  const childNodesForOptions = _.map(options, ({ key, config }) => {
    const selectedEvidencesCount = _.size(_.get(selectedEvidences, key, []));

    return {
      key,
      tier: CHILD_TIER,
      parent: "optionsNode",
      title: _.capitalize(t(config.label)),
      suffix:
        selectedEvidencesCount > 0 ? (
          <span className={itemCountClasses}>{selectedEvidencesCount}</span>
        ) : null,
    };
  });

  return [
    rootNode,
    ...childNodesForSuggestedEvidenceOptions,
    optionsNode,
    ...childNodesForOptions,
  ];
};

const Sidebar = props => {
  const {
    t,
    activeTab,
    updateActiveTab,
    evidenceOptions,
    suggestedEvidenceOptions,
    selectedCards,
    testId,
  } = props;

  return (
    <div className={classes.container}>
      <SideNavigation
        dsVersion="2.0"
        options={_getSidebarOptions({
          suggestedEvidenceOptions,
          options: evidenceOptions,
          t,
          selectedEvidences: selectedCards,
        })}
        selectedOptionKey={activeTab}
        onClick={updateActiveTab}
        testId={testId}
      />
    </div>
  );
};

export default Sidebar;
